import React, { useState, useRef, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import "../styles/que.css";
import { FaBell, FaUserCircle, FaSearch } from "react-icons/fa";
import axios from 'axios';
import { toast } from 'react-toastify';
const Questions = () => {
  const [searchQuery, setSearchQuery] = useState("");

  const [board, setBoard] = useState("");
  const [grade, setGrade] = useState("");
  const [subject, setSubject] = useState("");
  const [chapter, setChapter] = useState("");
  const [difficultylevel, setDifficultylevel] = useState("");
  const [questiontype, setQuestiontype] = useState("");
  const [difficulties, setDifficulties] = useState([]);

  // dropdown data
  const [boards, setBoards] = useState([]);
  const [grades, setGrades] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [chapters, setChapters] = useState([]);

  // questions
  const [allQuestions, setAllQuestions] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [activeItem, setActiveItem] = useState("questions");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dashboardData, setDashboardData] = useState({
    totalBoard: 0,
    totalGrade: 0,
    totalSubjects: 0,
    totalPapers: 0,
    totalQuestions: 0,
  });
  const [user, setUser] = useState({
    id: null,
    name: '',
    email: '',
    password: '',
  });

  // Fetch dashboard & user data
  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("https://digital.tifleducation.com/admin/public/api/getDashboard", {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (res.data) {
          setDashboardData({
            totalBoard: res.data.totalBoards || 0,
            totalGrade: res.data.totalGrades || 0,
            totalSubjects: res.data.totalSubjects || 0,
            totalPapers: res.data.totalPapers || 0,
            totalQuestions: res.data.totalQuestions || 0,
          });
          if (res.data.user) {
            setUser({
              id: res.data.user.id,
              name: res.data.user.name || '',
              email: res.data.user.email || '',
              password: '', // empty for editing
            });
          }
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error.response?.data || error);
      }
    };

    fetchDashboardData();
  }, []);
  // Handle save changes
  const handleSaveProfile = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        "https://digital.tifleducation.com/admin/public/api/update-profile",
        {
          name: user.name,
          password: user.password,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Profile updated successfully!");

      setIsModalOpen(false);
      setUser({ ...user, password: '' }); // reset password field
    } catch (error) {
      console.error("Error updating profile:", error.response?.data || error);

      toast.error("Failed to update profile");

    }
  };

  const token = localStorage.getItem("token");

  // ✅ Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const questionsPerPage = 10;

  // ✅ Helper to clean question text and extract images
  const extractImagesFromHTML = (html) => {
    if (!html) return { text: "", images: [] };

    const div = document.createElement("div");
    div.innerHTML = html;

    const images = Array.from(div.querySelectorAll("img")).map((img) => img.src);

    // Remove images from HTML so only text remains
    div.querySelectorAll("img").forEach((img) => img.remove());

    return { text: div.innerHTML, images };
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  // Fetch all data once
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`https://digital.tifleducation.com/admin/public/api/getQuestions`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) throw new Error("Failed to fetch questions");

        const data = await response.json();

        // ✅ universal handler for multiple response shapes
        let fetchedQuestions = [];
        if (Array.isArray(data.questions)) {
          fetchedQuestions = data.questions;
        } else if (Array.isArray(data.data)) {
          fetchedQuestions = data.data;
        } else if (Array.isArray(data)) {
          fetchedQuestions = data;
        } else if (data.data && Array.isArray(data.data.questions)) {
          fetchedQuestions = data.data.questions;
        }

        setAllQuestions(fetchedQuestions);
        setQuestions(fetchedQuestions);

        setBoards(data.boards || []);
        setGrades(data.grades || []);
        setSubjects(data.subjects || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token]);

  // Fetch chapters when subject changes
  useEffect(() => {
    if (!subject) {
      setChapters([]);
      return;
    }

    const params = new URLSearchParams({
      subject_id: subject,
    });

    if (grade) params.append("grade_id", grade);
    if (board) params.append("board_id", board);

    const fetchChapters = async () => {
      try {
        const response = await fetch(
          `https://digital.tifleducation.com/admin/public/api/get-chaptersbysubject?${params.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const data = await response.json();
        setChapters(data.chapters || []);
      } catch (err) {
        console.error("Failed to fetch chapters", err);
      }
    };

    fetchChapters();
  }, [subject, grade, board, token]);

  // Filter questions
  useEffect(() => {
    let filtered = allQuestions.filter((q) => {
      let match = true;
      if (board && q.board?.toString() !== board.toString()) match = false;
      if (grade && q.grade?.toString() !== grade.toString()) match = false;
      if (subject && q.subject?.toString() !== subject.toString()) match = false;
      if (chapter && q.chapter?.toString() !== chapter.toString()) match = false;
      if (difficultylevel && q.difficulty_level?.toString() !== difficultylevel.toString()) match = false;
      if (questiontype && q.question_type?.toString() !== questiontype.toString()) match = false;
      if (searchQuery && !q.question_title?.toLowerCase().includes(searchQuery.toLowerCase())) match = false;
      return match;
    });
    setQuestions(filtered);
  }, [board, grade, subject, chapter, difficultylevel, questiontype, searchQuery, allQuestions]);

  useEffect(() => {
    const fetchDifficulties = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          "https://digital.tifleducation.com/admin/public/api/difficulties",
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (res.data && Array.isArray(res.data)) {
          setDifficulties(res.data);
        } else if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // Laravel API format
          setDifficulties(res.data.data);
        } else {
          console.warn("Unexpected response format:", res.data);
          toast.info("No difficulty levels found");
        }
      } catch (error) {
        console.error("Error fetching difficulties:", error.response?.data || error);
        toast.error("Failed to load difficulty levels");
      }
    };

    fetchDifficulties();
  }, []);

  // ✅ Pagination logic
  const indexOfLastQuestion = currentPage * questionsPerPage;
  const indexOfFirstQuestion = indexOfLastQuestion - questionsPerPage;
  const currentQuestions = questions.slice(indexOfFirstQuestion, indexOfLastQuestion);
  const totalPages = Math.ceil(questions.length / questionsPerPage);

  return (
    <div className="dashboard-container">
      <Sidebar
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />

      <main className="main-content">
        <div className="que-header">
          <div className="que-welcome-text">
            <a href="/dashboard" className="back-link">
              <i className="fa fa-arrow-left" aria-hidden="true"></i>
            </a>
            <span className="que-welcome-text">Questions</span>
          </div>
          <div className="header-icons" ref={dropdownRef}>
            <FaBell className="icon" />
            <div className="user-dropdown-wrapper">
              <FaUserCircle className="icon" onClick={toggleDropdown} />
              {showDropdown && (
                <div className="user-dropdown">
                  <div className='edituser' onClick={() => setIsModalOpen(true)}>
                    <FaUserCircle className="ditusericon" />
                    <span>Edit Profile</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Dynamic Dropdowns */}
        <div className="dropdown-row">
          {/* Board */}
          <div className="dropdown-group">
            <label>Board</label>
            <select value={board} onChange={(e) => setBoard(e.target.value)}>
              <option value="">Select Board</option>
              {boards.map((b) => (
                <option key={b.id} value={b.id}>
                  {b.name}
                </option>
              ))}
            </select>
          </div>

          {/* Grade */}
          <div className="dropdown-group">
            <label>Grade</label>
            <select value={grade} onChange={(e) => setGrade(e.target.value)}>
              <option value="">Select Grade</option>
              {grades.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.name}
                </option>
              ))}
            </select>
          </div>

          {/* Subject */}
          <div className="dropdown-group">
            <label>Subject</label>
            <select value={subject} onChange={(e) => setSubject(e.target.value)}>
              <option value="">Select Subject</option>
              {subjects.map((sub) => (
                <option key={sub.id} value={sub.id}>
                  {sub.name}
                </option>
              ))}
            </select>
          </div>

          {/* Chapter */}
          <div className="dropdown-group">
            <label>Chapter</label>
            <select value={chapter} onChange={(e) => setChapter(e.target.value)}>
              <option value="">Select Chapter</option>
              {chapters.map((ch) => (
                <option key={ch.id} value={ch.id}>
                  {ch.chapter_name}
                </option>
              ))}
            </select>
          </div>

          {/* Difficulty */}
          <div className="dropdown-group">
            <label>Difficulty Level</label>
            <select
              value={difficultylevel}
              onChange={(e) => setDifficultylevel(e.target.value)}
            >
              <option value="">Select Difficulty</option>
              {difficulties.length ? (
                difficulties.map((d) => (
                  <option key={d.id} value={d.name || d.level || d.difficulty}>
                    {d.name || d.level || d.difficulty}
                  </option>
                ))
              ) : (
                <option value="" disabled>Loading difficulties...</option>
              )}
            </select>
          </div>

          {/* Type */}
          <div className="dropdown-group">
            <label>Question Type</label>
            <select value={questiontype} onChange={(e) => setQuestiontype(e.target.value)}>
              <option value="">Select Question Type</option>
              <option value="M.C.Q">M.C.Q</option>
              <option value="True-False">True-False</option>
              <option value="Fill in the blanks">Fill in the blanks</option>
              <option value="Very Short Question Answer">Very Short Question Answer</option>
              <option value="Short Question Answer">Short Question Answer</option>
              <option value="Long Question Answer">Long Question Answer</option>
              <option value="Diagram-Based_Image-Based Questions">Diagram-Based/Image-Based Questions</option>
              <option value="Matching Types">Matching Types</option>
            </select>
          </div>
        </div>

        {/* Search */}
        <div className="search-bar-container">
          <div className="search-input-wrapper">
            <FaSearch className="search-icon" />
            <input
              type="text"
              className="search-input"
              placeholder="Search questions..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>

        {/* Questions */}
        <div className="question-content">
          {loading && <p>Loading...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}
          {!loading && Array.isArray(questions) && questions.length === 0 && <p>No questions found.</p>}

          {Array.isArray(currentQuestions) &&
            currentQuestions.map((q, index) => {
              const { text: cleanQuestion, images: questionImages } = extractImagesFromHTML(q.question_title);

              return (
                <div key={q.id || index} className="mcq2-box">
                  <div className="checkbox-line">
                    <div className="mcq2-question">
                      <span style={{ display: "flex", alignItems: "center", gap: "2" }}
                        dangerouslySetInnerHTML={{
                          __html: `${indexOfFirstQuestion + index + 1}. ${cleanQuestion}`,
                        }}
                      />
                      {questionImages.length > 0 && (
                        <div className="image-question">
                          {questionImages.map((src, i) => (
                            <img key={i} src={src} alt={`Question Image`} className="question-image" />
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* M.C.Q */}
                  {q.question_type === "M.C.Q" && q.options && Array.isArray(q.options) && (
                    <div className="row mcq2-options">
                      {q.options.map((opt, i) => {
                        const { text: cleanOpt, images: optImages } = extractImagesFromHTML(opt);
                        return (
                          <div key={i} className="col-md-3 d-flex flex-column">
                            <div className="d-flex">
                              <strong className="me-2">{String.fromCharCode(65 + i)}.</strong>
                              <span dangerouslySetInnerHTML={{ __html: cleanOpt }} />
                            </div>
                            {optImages.length > 0 && (
                              <div className="image-question">
                                {optImages.map((src, j) => (
                                  <img key={j} src={src} alt={`Option ${j}`} className="question-image" />
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {/* True / False */}
                  {q.question_type === "True-False" && (
                    <p style={{ paddingLeft: 20, paddingRight: 20 }}>
                      <em>(True / False)</em>
                    </p>
                  )}

                  {/* Matching Types */}
                  {q.question_type === "Matching Types" && (
                    <div className="que-row">
                      <div className="col-6">
                        {q.left_column &&
                          q.left_column.split(/<\/p>/).map((left, i) =>
                            left.trim() !== "" ? (
                              <div key={i} dangerouslySetInnerHTML={{ __html: left + "</p>" }} />
                            ) : null
                          )}
                      </div>
                      <div className="col-6">
                        {q.right_column &&
                          q.right_column.split(/<\/p>/).map((right, i) =>
                            right.trim() !== "" ? (
                              <div key={i} dangerouslySetInnerHTML={{ __html: right + "</p>" }} />
                            ) : null
                          )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
        </div>

        {/* Pagination */}
        <div className="pagination-container">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => (
            <button
              key={i}
              className={currentPage === i + 1 ? "active-page" : ""}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          >
            Next
          </button>
        </div>
      </main>
      {/* Profile Edit Modal */}
      {isModalOpen && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <button style={modalStyles.closeBtn} onClick={() => setIsModalOpen(false)}>&times;</button>
            <div style={modalStyles.userIcon}><FaUserCircle /></div>

            <div style={modalStyles.formGroup}>
              <label>Username</label>
              <input
                type="text"
                value={user.name}
                onChange={(e) => setUser({ ...user, name: e.target.value })}
                style={modalStyles.input}
              />
            </div>

            <div style={modalStyles.formGroup}>
              <label>Email</label>
              <input type="email" value={user.email} disabled style={{ ...modalStyles.input, background: '#f0f0f0', color: '#888' }} />
            </div>

            <div style={modalStyles.formGroup}>
              <label>Password</label>
              <input
                type="password"
                value={user.password}
                onChange={(e) => setUser({ ...user, password: e.target.value })}
                style={modalStyles.input}
              />
            </div>

            <div style={{ textAlign: 'right' }}>
              <button style={modalStyles.saveBtn} onClick={handleSaveProfile}>Save Changes</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// Modal inline styles
const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0, left: 0, width: "100%", height: "100%",
    background: "rgba(0,0,0,0.6)",
    display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000
  },
  modal: {
    background: "#fff", padding: "2rem", borderRadius: "12px",
    width: "90%", maxWidth: "400px", position: "relative",
    boxShadow: "0 4px 15px rgba(0,0,0,0.2)"
  },
  closeBtn: {
    position: "absolute", top: "10px", right: "15px",
    background: "none", border: "none", fontSize: "1.5rem", cursor: "pointer"
  },
  userIcon: {
    textAlign: "center", fontSize: "4rem", color: "#129255", marginBottom: "1rem"
  },
  formGroup: { marginBottom: "1rem" },
  input: { width: "100%", padding: "0.5rem 0.8rem", borderRadius: "6px", border: "1px solid #ccc", outline: "none" },
  saveBtn: { background: "#129255", color: "#fff", border: "none", padding: "0.6rem 1.2rem", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }
};

export default Questions;
